define('views/modules/profile/edit/personal-info-edit-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/api',
    'services/i18n',
    // models
    'collections/commons/locales',
    'collections/commons/country',
    'collections/commons/province',
    'collections/commons/timezone',
    // views
    'views/parts/form/textbox',
    'views/parts/form/select',
    'views/parts/form/datepicker',
    'views/parts/form/choices',
    'views/parts/info-section',
    // templates
    'text!templates/modules/profile/edit/personal-info-edit-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    API,
    i18n,
    // models
    CLocales,
    CCountry,
    CProvinces,
    CTimezones,
    // views
    VTextBox,
    VSelect,
    VDatePicker,
    VChoices,
    VInfoSection,
    // templates
    TPersonalInfoEditForm
) {

    var VPersonalInfoEditForm = Backbone.View.extend({
        template: TPersonalInfoEditForm,

        regions: {
            form: {
                language: '.language-input',
                gender: '.gender-input',
                birthdate: '.birthdate-input',
                phone: '.phone-input',
                country: '.country-input',
                province: '.province-input',
                city: '.city-input',
                timezone: '.timezone-input',
                heightUnit: '.height-unit-input',
                heightValueCm: '.height-value-cm-input',
                inchHeight: '.inch-height',
                heightValueFeet: '.height-value-feet-input',
                heightValueInch: '.height-value-inch-input',
                heightFeetCol: '.height-value-feet',
                heightCmCol: '.height-value-cm',
            }
        },
        initialize: function(opt) {
            this.options = opt || {};

            this.locales = new CLocales();
            this.countries = new CCountry();
            this.provinces = new CProvinces();
            this.timezones = new CTimezones();

            this.heightFeet = new Backbone.Collection([
                { value: 2 },
                { value: 3 },
                { value: 4 },
                { value: 5 },
                { value: 6 },
                { value: 7 },
            ]);

            this.heightInch = this.getInchCollection();

            this.view = {
                info: new VInfoSection({
                    title: "Personal Information",
                    //help: "messages:helpbox-personal-information",
                    content: this.template,
                }),
                form: {
                    language: new VSelect({
                        label: 'form-profile-language',
                        attribute: 'language',
                        labelposition: "left",
                        option: { namespace: 'languages' },
                        model: this.model,
                        collection: this.locales
                    }),
                    gender: new VChoices({
                        model: this.model,
                        radio: true,
                        styleButton: true,
                        groupLabel: 'Gender',
                        attribute: 'gender',
                        labelposition: "left",
                        addClass: "btn-group-justified",
                        choices: [
                            { label: 'Male', value: 'male' },
                            { label: 'Female', value: 'female' }
                        ]
                    }),
                    birthdate: new VDatePicker({
                        label: 'form-profile-birthdate',
                        labelposition: "top",
                        attribute: 'birthdate',
                        model: this.model,
                        multidate: false,
                    }),
                    country: new VSelect({
                        label: 'form-profile-country',
                        attribute: 'country',
                        labelposition: "left",
                        model: this.model,
                        config: {
                            container: 'body',
                        },
                        collection: this.getTranslatedCollection(this.countries, 'countries')
                    }),
                    province: new VSelect({
                        label: 'form-profile-province',
                        attribute: 'province',
                        labelposition: "left",
                        model: this.model,
                        collection: this.getTranslatedCollection(this.provinces, 'provinces')
                    }),
                    city: new VTextBox({ label: 'form-profile-city', attribute: 'city', labelposition: "top", model: this.model }),
                    phone: new VTextBox({ placeholder: 'form-profile-phone-placeholder', label: 'form-profile-phone', help: 'form-profile-phone-help', attribute: 'phone', labelposition: "top", model: this.model }),
                    timezone: new VSelect({
                        label: 'form-profile-timezone',
                        attribute: 'timezone',
                        labelposition: "top",
                        option: { namespace: 'timezones' },
                        model: this.model,
                        collection: this.timezones
                    }),
                    heightUnit: new VChoices({
                        model: this.model,
                        radio: true,
                        styleButton: true,
                        // groupLabel: 'Height',
                        attribute: 'heightUnit',
                        labelposition: "top",
                        onChange: this.onHeightUnitChange,
                        context: this,
                        choices: [
                            { label: 'in', value: 'in' },
                            { label: 'cm', value: 'cm' }
                        ]
                    }),
                    heightValueCm: new VTextBox({ attribute: 'heightValue', model: this.model, labelposition: "top", addClass: 'smaller-input' }),
                    heightValueFeet: new VSelect({
                        option: { label: 'value', value: 'value', skipTranslation: true },
                        attribute: 'value',
                        addClass: 'btn-sm',
                        collection: this.heightFeet,
                        context: this,
                        onChange: this.onInchChange
                    }),
                    heightValueInch: new VSelect({
                        option: { label: 'value', value: 'value', skipTranslation: true },
                        attribute: 'value',
                        addClass: 'btn-sm',
                        collection: this.heightInch,
                        context: this,
                        onChange: this.onInchChange
                    })
                }
            };

            this.listenTo(this.model, {
                'change:country': this.onCountryChange,
                'change:language': this.onLanguageChange
            });

        },
        render: function() {

            // append the form
            this.assign(this.view.info, this.$el);

            this.generateZones();
            var view = this.view,
                zone = this.zone,
                model = this.model;

            this.assign(view.form.language, zone.form.$language)
                .assign(view.form.gender, zone.form.$gender)
                .assign(view.form.birthdate, zone.form.$birthdate)
                .assign(view.form.country, zone.form.$country)
                .assign(view.form.province, zone.form.$province)
                .assign(view.form.city, zone.form.$city)
                .assign(view.form.phone, zone.form.$phone)
                .assign(view.form.timezone, zone.form.$timezone)
                .assign(view.form.heightUnit, zone.form.$heightUnit)
                .assign(view.form.heightValueFeet, zone.form.$heightValueFeet)
                .assign(view.form.heightValueInch, zone.form.$heightValueInch)
                .assign(view.form.heightValueCm, zone.form.$heightValueCm);

            if (model.get('lengthUnit') === 'in') {
                var inchObject = this.model.convertInchToFeetAndInches();
                this.setInchAndFeetModels(inchObject);
            }

            zone.form.$province.toggle(model.isFromCanada());

            this.toggleHeightInputs();

            return this;
        },

        getTranslatedCollection: function(collection, ns) {
            var newCollection = new Backbone.Collection();

            newCollection.comparator = function(a, b) {
                return a.get('name').localeCompare(b.get('name'));
            };

            newCollection.add(
                _.map(collection.models, function(model) {
                    return model.set('name', i18n.t(model.get('name'), { ns: ns }));
                })
            );

            return newCollection;
        },

        getInchCollection: function() {
            var collection = new Backbone.Collection([]);
            _(13).times(function(n) {
                collection.add({ value: n });
            });

            return collection;
        },

        // need to set select empty models
        setInchAndFeetModels: function(inchObject) {
            var view = this.view.form;
            view.heightValueFeet.model.set('value', inchObject.feet, { silent: true });
            view.heightValueInch.model.set('value', inchObject.inch, { silent: true });
            view.heightValueFeet.setValue(inchObject.feet);
            view.heightValueInch.setValue(inchObject.inch);

            if (inchObject.feet < 2) { view.heightValueFeet.setValue(2); }
            if (inchObject.feet > 7) { view.heightValueFeet.setValue(7); }
        },

        toggleHeightInputs: function() {
            var zone = this.zone.form;
            var isInch = this.model.get('lengthUnit') === 'in';
            var isCm = !isInch;

            zone.$heightCmCol.toggle(isCm);
            zone.$heightFeetCol.toggle(isInch);
        },

        ////////////
        // events //
        ////////////

        onHeightUnitChange: function(model, value) {
            var view = this.view.form;
            // cm to in
            if (value === 'in') {
                // returns { feet: 3 , inch: 7 }
                var inchObject = model.convertHeightTo(value);
                this.setInchAndFeetModels(inchObject);
            } else { // in to cm
                model.convertHeightTo(value);
            }

            // setting lengthUnit to be sync with heightUnit
            model.set('lengthUnit', value);

            this.toggleHeightInputs();
        },

        onInchChange: function(model, value) {
            var view = this.view.form,
                inch = parseInt(view.heightValueInch.getValue()),
                feet = parseInt(view.heightValueFeet.getValue());

            // seting without feets, only inches
            this.model.set('heightValue', feet * 12 + inch);
        },

        onCountryChange: function(model, value) {
            if (this.zone) {
              this.zone.form.$province.toggle(value === 'CA');
            }
        },

        onLanguageChange: function(model, language) {
            i18n.setLanguage(language.replace('_', '-'));
        },



    });

    return VPersonalInfoEditForm;
});

